import { render, staticRenderFns } from "./ApproveWebpartTest.vue?vue&type=template&id=088b22c3"
import script from "./ApproveWebpartTest.vue?vue&type=script&lang=js"
export * from "./ApproveWebpartTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports